import {action, makeObservable, runInAction} from "mobx";
import {BaseListStore} from "app/modules/common/stores/BaseListStore";
import {inject} from "react-ioc";
import {ApiClients} from "app/modules/organization/services/AxiosBaseClient";
import {FieldState, FormState} from "formstate";
import {
    DataListGetParamsOfUserListFilters,
    UserListFilters,
    UserListModel
} from "app/modules/organization/api/clients.api";
import React from "react";
import {DialogStore} from "app/modules/common/dialog/DialogStore";
import {DialogUserNew} from "app/modules/organization/components/users/dialog.user.new";

export class UsersStore extends BaseListStore<UserListModel>{
    @inject apiClients: ApiClients;
    @inject dialogStore: DialogStore;

    filters = new FormState({
        search: new FieldState('')
    })

    constructor() {
        super();

        makeObservable(this, {
            init: action
        });
    }

    applySpecificFilters() {
    }

    async loadData() {
        this.wrapLoadingApiCall(async () => {
            let filters = new UserListFilters({search: this.filters.$.search.value});
            const [result] = await Promise.all([
                this.apiClients.userClient.getUsers(new DataListGetParamsOfUserListFilters({
                    offset: this.skipRows,
                    pageSize: this.pageSize,
                    filter: filters
                }))
            ]);

            this.items = result.items;
            this.totalRows = result.count;
        });
    }

    createNewUser = () => {
        const key = "new_user";
        this.dialogStore.addDialog({
            key: key,
            component: <DialogUserNew closeModal={() => this.dialogStore.closeDialog(key)} onAdded={async () => {
                this.dialogStore.closeDialog(key);
                await this.loadData();
            }} title="Create User"/>
        });
    }

    async init() {
        await this.loadData();

        runInAction(() => {
            this.isInitLoading = false;
        })
    }
}
